import { isEmpty, isIsoDate } from "./utils"

export function validateSync(def: any, values: Record<string, unknown>): string {
    if (!def) return ""

    const name = def.name
    const value = values[name]
    const rules = def.rules || []

    for (const rule of rules) {

        if (rule.type === "required") {
            if (def.type === "checkbox") {
                if (value !== true) {
                    return rule.message || "Pflichtfeld"
                }
                continue
            }

            if (isEmpty(value)) {
                return rule.message || "Pflichtfeld"
            }
            continue
        }

        if (isEmpty(value)) continue

        if (rule.type === "dateBefore") {
            if (isIsoDate(value) && value >= rule.value) {
                return rule.message || `Muss vor ${rule.value} liegen`
            }
        }

        if (rule.type === "dateAfter") {
            if (isIsoDate(value) && value <= rule.value) {
                return rule.message || `Muss nach ${rule.value} liegen`
            }
        }

        if (rule.type === "dateBetween") {
            const from = values[rule.fromField]
            const to = values[rule.toField]

            if (isIsoDate(value) && isIsoDate(from) && isIsoDate(to)) {
                if (value < from || value > to) {
                    return rule.message || "Datum liegt außerhalb des Zeitraums"
                }
            }
        }

        if (rule.type === "dateOutside") {
            const from = values[rule.fromField]
            const to = values[rule.toField]

            if (isIsoDate(value) && isIsoDate(from) && isIsoDate(to)) {
                if (value >= from && value <= to) {
                    return rule.message || "Datum liegt im gesperrten Zeitraum"
                }
            }
        }
    }

    return ""
}
